export default __webpack_public_path__ + "static/media/cao-e-gato-consumidor.c5897a1d.png";